import React, { useEffect, useState } from 'react'
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';
import { GetImagePartResponse } from '@/main/models/response';
import ResultNotFoundComponent from '@/main/components/shared/resultNotFound/resultNotFoundComponent';
import { getTranslateByKey, openNewTabExternalLink } from '@/main/services/utils';
import KogModalSlideImages from '@/main/components/shared/KogModalSlideImages/modalSlideImages';
import * as S from './styles';

interface IModalImagesReturnProps {
  guidProcurementSupplierItem: string;
  dataImages: GetImagePartResponse[];
  isLoadingImages: boolean;
}
function ModalImagesReturn({
  guidProcurementSupplierItem,
  dataImages,
  isLoadingImages
}: IModalImagesReturnProps) {


  const [imageIndex, setImageIndex] = useState(0);
  const [isOpenModalFade, setIsOpenModalFade] = useState<boolean>(false);
  const [images, setImages] = useState<string[]>([]);

  function handleClickPreview(urlFile: string) {
    const index = dataImages.findIndex(item => item.externalKey === urlFile);
    setImageIndex(index);
    setIsOpenModalFade(true);
  }

  useEffect(() => {
    if (dataImages && dataImages.length > 0) {
      let imagesString: string[] = [];
      dataImages.map((item) => {
        if (item.externalKey) {
          imagesString.push(item.externalKey);
        }
      });
      return setImages(imagesString);
    }
    return setImages([]);
  }, [dataImages])

  if (isLoadingImages) return (<LoadingComponent />);
  if (!isLoadingImages && dataImages.length === 0) return <ResultNotFoundComponent messageCustom={getTranslateByKey('information.noImagesFound')} />

  return (
    <>
      <S.Container>
        {dataImages.map((image) => (
          <S.BoxImage>
            <S.Image
              src={image.externalKey}
              onClick={() => {
                handleClickPreview(image.externalKey);
              }}
            />
          </S.BoxImage>
        ))}
      </S.Container>
      {dataImages && dataImages.length > 0 && (
        <KogModalSlideImages
          images={images}
          imageIndex={imageIndex}
          isOpen={isOpenModalFade}
          setIsOpen={setIsOpenModalFade}
          isInModal
        />
      )}
    </>
  )
}

export default ModalImagesReturn